<template>
    <div data-testid="step-currency" class="container">
        <h1 class="container__standard-header">
            {{ $t(`${TRANSLATION_KEY}.stepCurrencyHeader`) }}
        </h1>
        <p
            v-if="isStocksAccountType"
            class="t-center t-bold container__subheader"
        >
            {{ $t(`${TRANSLATION_KEY}.accountInfoStocks`) }}
        </p>
        <p v-else class="t-center t-bold container__subheader">
            {{ $t(`${TRANSLATION_KEY}.accountInfo`) }}
        </p>
        <form @submit.prevent="null">
            <div class="row custom-select-wrapper">
                <Select
                    name="currencyChoice"
                    :item-list="currencies"
                    :label="$t(`${TRANSLATION_KEY}.currency`)"
                    :placeholder="
                        $t(`${TRANSLATION_KEY}.chooseCurrencyPlaceholder`)
                    "
                    cy-data="currency"
                    @update:model-value="formData.currencyChoice = $event"
                />
            </div>
            <SubmitButton
                :action="Action.CURRENCY"
                :button-value="$t(`${TRANSLATION_KEY}.next`)"
                data-testid="btn-currency-nextStep"
                :data="formData"
                class="button button--submit"
                @click="handleNextStep"
            />
        </form>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue';
import config from '@/json/config.json';
import SubmitButton from '@/components/basic/buttons/SubmitButton.vue';
import Select from '@/components/basic/fields/Select.vue';
import { useI18n } from 'vue-i18n';
import {
    AmplitudeAnalyticsEvents,
    amplitudeSendEvent,
} from '@/utils/AmplitudeAnalyticsEvents';
import { useStore } from 'vuex';
import { SET_PROGRESS } from '@/constants/mutation-types';
import { PROGRESS_BAR_TIMES } from '@/constants/progress-bar-times';
import { Action } from '@/constants/ajax';

export default defineComponent({
    name: 'CurrencySelection',
    components: {
        Select,
        SubmitButton,
    },
    setup() {
        const store = useStore();
        const TRANSLATION_KEY = 'steps.Currency';
        const formData = ref({
            currencyChoice: '',
        });

        const { locale } = useI18n();


        const isStocksAccountType = computed(() => {
            const accountType =
                store.state.formData.accountType ??
                store.state.response?.dataContent?.accountType ??
                null;
            return accountType == 2;
        });

        const isCzkCurrencyAllowed = computed(() =>
            !isStocksAccountType.value
            ||
            (
                isStocksAccountType.value
                &&
                (store.state.formData.isDebugEmail ??
                    store.state.response?.dataContent?.isDebugEmail) === true
                &&
                (store.state.formData.isCzechClient ??
                    store.state.response?.dataContent?.isCzechClient) === true
            )
        );


        const currencies = computed(() => {
            const lang = locale.value.toUpperCase();
            let list = config.currencies;
            if (lang === 'PL' || !isCzkCurrencyAllowed.value) {
                list = list.filter((currency) => currency.value !== 'CZK');
            }
            
            return list;
        });

        const handleNextStep = () => {
            const selectedCurrency = config.currencies.find(
                (currency) =>
                    currency.key.toString() === formData.value.currencyChoice
            );
            if (selectedCurrency) {
                amplitudeSendEvent(
                    AmplitudeAnalyticsEvents.currency.CURRENCY(
                        selectedCurrency.value
                    )
                );
            }
            amplitudeSendEvent(
                AmplitudeAnalyticsEvents.currency.CURRENCY_CONTINUE
            );
        };

        onMounted(() => {
            store.commit(SET_PROGRESS, PROGRESS_BAR_TIMES.CURRENCY);
        });

        return {
            TRANSLATION_KEY,
            Action,
            currencies,
            formData,
            handleNextStep,
            isStocksAccountType,
        };
    },
});
</script>
